var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notes-table',{staticClass:"ma-0 pa-0",attrs:{"data":_vm.notes,"readonly":_vm.viewonly,"title":"Customer Notes"},on:{"save":_vm.saveNote,"delete":_vm.deleteNote}})
}
var staticRenderFns = []

export { render, staticRenderFns }